import React, { useState } from 'react'
import { api } from 'components/api'
import { createUserPath } from 'components/routes/api'
import { OrganizationPicker } from 'components/sso/OrganizationPicker'
import HeaderIcon from 'images/authentication_modals/sign-up.svg'

interface Organization {
  id: number
  name: string
}

interface Props {
  name: string
  email: string
  organizations: Organization[]
  subHeaderMessage?: React.ReactNode
  onSuccess: () => void
  onGoBack?: () => void
}

interface CreateUserResponse {
  status: string
  errors?: { user: Record<string, string> }
}

const DEFAULT_ERROR_MESSAGE = "We're sorry there was an error"

function ConfirmOrganization (props: Props): React.ReactElement {
  const { name, email, organizations, subHeaderMessage, onSuccess, onGoBack } = props
  const [organizationId, setOrganizationId] = useState('')
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [error, setError] = useState('')

  const handleSubmit = (e: React.FormEvent): void => {
    e.preventDefault()
    setIsSubmitting(true)
    setError('')

    api.postWithCsrf({
      url: createUserPath(),
      data: {
        user: {
          name,
          email,
          organization_id: organizationId,
          signup_source: `Email Domain Match (Signup Modal ${window.location.pathname})`
        }
      }
    }).then((response) => {
      const data = response.data as CreateUserResponse
      if (data.status === 'success') {
        onSuccess()
      } else {
        setIsSubmitting(false)
        setError(Object.values(data.errors?.user ?? {})[0] ?? DEFAULT_ERROR_MESSAGE)
      }
    }).catch(() => {
      setIsSubmitting(false)
      setError(DEFAULT_ERROR_MESSAGE)
    })
  }

  return (
    <form id='auth-confirm-organization-form' onSubmit={handleSubmit}>
      <div className='modal-top'>
        <img src={HeaderIcon} className='header-icon' />
        <div className='header pro-head-5' role='heading'>Confirm your Organization</div>
        {subHeaderMessage}
      </div>
      <div className='modal-bottom'>
        <OrganizationPicker
          candidates={organizations}
          onChange={setOrganizationId}
          disabled={isSubmitting}
        />

        {error !== '' && <div className='error'>{error}</div>}

        <div className='grid-x align-middle buttons'>
          <div className='cell small-6'>
            {onGoBack !== undefined &&
              <a onClick={onGoBack} className='go-back-btn'>Go Back</a>}
          </div>
          <div className='cell small-6'>
            <button
              type='submit'
              disabled={organizationId === '' || isSubmitting}
              className='button submit-btn float-right'
            >
              NEXT
            </button>
          </div>
        </div>
      </div>
    </form>
  )
}

export default ConfirmOrganization
